var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CardElement",class:{
    'row-fluid': _vm.isFluid,
    'row': (!_vm.isFluid && _vm.isFull),
    'tight': _vm.tight }},[_c('div',{staticClass:"CardWrap",class:{
      'columns': (!_vm.isFluid && !_vm.isFull),
      'small-12': (!_vm.isFluid && _vm.isFull),
      'small-6': (!_vm.isFluid && _vm.isHalf),
      'small-4': (!_vm.isFluid && _vm.isThird),
      'small-3': (!_vm.isFluid && _vm.isQuarter),
      'cardFull': _vm.isFull,
      'cardHalf': _vm.isHalf,
      'cardThird': _vm.isThird,
      'cardQuarter': _vm.isQuarter,
      'padBottom': _vm.padBottom },style:({
    backgroundColor: _vm.backgroundColor,
    backgroundImage: _vm.backgroundImage,
    backgroundSize: _vm.backgroundSize,
    backgroundPosition: _vm.backgroundPosition,
    backgroundRepeat: _vm.backgroundRepeat,
    padding: _vm.padding,
    'height': _vm.calculatedHeight,
    'width': _vm.calculatedWidth })},[_c('div',{staticClass:"CardOuterWrap",class:{ 'row': _vm.isFluid }},[_c('div',{staticClass:"CardInnerWrap",class:{ 'small-12 columns': _vm.isFluid }},[(_vm.button.url)?_c('a',{staticClass:"contentBox",style:(_vm.calculatedStyle),attrs:{"href":_vm.button.url}},[_vm._t("default")],2):_c('div',{staticClass:"contentBox",style:(_vm.calculatedStyle)},[_vm._t("default")],2)]),_vm._v(" "),_c('div',{staticClass:"clear"})]),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []
export { render, staticRenderFns }